import { faDollarCircle } from '@fortawesome/pro-solid-svg-icons/faDollarCircle'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { COMMUNITY_TYPE } from 'src/client/types'
import { Icon } from 'src/components'
import { CommunityBadgeProps } from './communityBadge.types'

const CommunityBadge = ({ communityType, className }: CommunityBadgeProps) => {
  switch (communityType) {
    case COMMUNITY_TYPE.EXCLUSIVE:
      return <Icon color="var(--yellow)" icon={faStar} className={className} />

    case COMMUNITY_TYPE.PAID:
      return <Icon color="var(--green-darker)" icon={faDollarCircle} className={className} />

    default:
      return null
  }
}

export default CommunityBadge
